<div class="container"
     ngClass.lt-md="container-sm"
     ngClass.xs="container-xs">
  <h2 class="heading">Closing requirements</h2>
  <div class="list">
    <div class="item"
         [ngClass]="{'mat-light-grey': requirement.status === checkoutRequirementStatus.Approved}"
         *ngFor="let requirement of checkoutRequirements | filter:filterFunction">
      <mat-icon class="icon"
                matListItemIcon>{{requirement.status === checkoutRequirementStatus.Approved ? 'check_circle' : 'trip_origin'}}</mat-icon>
      <span>{{requirement.requiredDocument}}{{requirement.notes ? ': ' + requirement.notes : ''}}</span>
    </div>
  </div>
</div>
